

export {OfferVehiclesAndState} from "./vehicles";
export {OfferInfo} from "./detail";

export {reducer }  from './reducer';
